export default __webpack_public_path__ + "static/media/tooltip2D-simple.7d138402.png";